<template>
  <div class="slide">
    <v-head></v-head>
    <div class="slide_content clearfix">
        {{{slide_new}}}
        <!--<div class="slide_content_title">
           <h2>星光盛会丨NAERSI 20周年时尚盛典</h2>
        </div>
      <div class="slide_content_head">
        2015年7月8日，深圳蛇口希尔顿南海酒店，“自信相随·NAERSI 20周年时尚盛典”闪耀启动，揭开第十五届中国（深圳）
        国际品牌服装服饰交易会的序幕。活动现场，名流政要，星光熠熠。时尚达人、主流媒体等纷纷到场祝贺，
        更有陆毅、鲍蕾、瞿颖、伊一、朱桦、徐洁儿、路晨、周知、那广子、王梦雅等影视明星、超模倾情助阵，见证NAERSI 20周年时尚盛典。
      </div>
      <ul class="slide_content_ul">
        <li>
          <p><strong>NO.1 创意签到区</strong></p>
          <ul>
            <li>
              <span class="slide_content_img">
                <img src="../../../static/images/slide1.jpg" alt="">
              </span>
              <div><span class="triangle"></span>扫描二维码，点亮星星签到</div>
            </li>
          </ul>
        </li>
        <li>
          <p><strong>NO.1 创意签到区</strong></p>
          <ul>
            <li>
              <span class="slide_content_img">
                <img src="../../../static/images/slide2.jpg" alt="">
              </span>
              <div><span class="triangle"></span>扫描二维码，点亮星星签到</div>
            </li>
            <li>
              <span class="slide_content_img">
                <img src="../../../static/images/slide3.jpg" alt="">
              </span>
              <div><span class="triangle"></span>扫描二维码，点亮星星签到</div>
            </li>
            <li>
              <span class="slide_content_img">
                <img src="../../../static/images/slide4.jpg" alt="">
              </span>
              <div><span class="triangle"></span>扫描二维码，点亮星星签到</div>
            </li>
          </ul>
        </li>
        <li>
          <p><strong>NO.1 创意签到区</strong></p>
          <ul>
            <li>
              <span class="slide_content_img">
                <img src="../../../static/images/slide5.jpg" alt="">
              </span>
              <div><span class="triangle"></span>扫描二维码，点亮星星签到</div>
            </li>
          </ul>
        </li>
      </ul>-->
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {
          slide_new:""
      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    methods:{

    },
    ready () {
      var _this = this;
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getNewsById/" + _this.$route.params.id,
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
            _this.slide_new = data.content;
            console.log(898989,data);
          }
        }
      });

    }
  }
</script>

<style>
  .slide{width: 9rem;margin: 0 auto;font-size: 0.18rem}
  .slide_content{width:9rem;margin-top: 0.5rem;}
  .slide_content_title{border-bottom: 0.01rem solid #000000;text-align: center}
  .slide_content_title h2{margin-bottom: 0.2rem}
  .triangle{width: 0;  height: 0; border-left: 0.06rem solid transparent; border-right: 0.06rem solid transparent; border-bottom: 0.12rem solid #000000;}
  .slide_content_head{font-size: 0.14rem;width: 5.8rem;margin: 0.5rem auto;line-height: 0.2rem}
  .slide_content_ul{margin: 0 auto;width: 5.8rem}
  .slide_content_ul>li>p{margin-bottom: 0.1rem;font-size: 0.14rem;margin-top: 0.2rem;}
  .slide_content_ul li div{font-size: 0.14rem;margin-bottom: 0.1rem}
  .slide_content_ul li div span{display: inline-block}
  .slide_content_img{margin-bottom: 0.1rem;display: inline-block}
  @media screen and (max-width: 30em) and (min-width:20em ){
    .slide{width: 100%;margin: 0 auto;font-size: 0.18rem}
    .slide_content{width:100%;margin-top: 0.8rem;}
    .slide_content img{width: 100% !important;}
    .slide_content_title{border-bottom: 0.01rem solid #000000;text-align: center;width: 100%}
    .slide_content_title h2{margin-bottom: 0.2rem;font-size: 0.18rem;width: 100%;}
    .triangle{width: 0;  height: 0; border-left: 0.06rem solid transparent; border-right: 0.06rem solid transparent; border-bottom: 0.12rem solid #000000;}
    .slide_content_head{font-size: 0.14rem;width: 90%;margin: 0.5rem auto;line-height: 0.2rem}
    .slide_content_ul{margin: 0 auto;width: 100%}
    .slide_content_ul img{width: 100%;height: 100%}
    .slide_content_ul>li>p{margin-bottom: 0.1rem;font-size: 0.14rem;margin-top: 0.2rem;}
    .slide_content_ul li div{font-size: 0.14rem;margin-bottom: 0.1rem}
    .slide_content_ul li div span{display: inline-block}
    .slide_content_img{margin-bottom: 0.1rem;display: inline-block}
  }


</style>



// WEBPACK FOOTER //
// slide.vue?9b489dfe